import type { Key } from 'react';
import { useMemo } from 'react';

/** Keep selection col narrow (matches emails; antd otherwise fills leftover width). */
export const FILES_TABLE_SELECTION_COLUMN_WIDTH = 48;

/**
 * Builds Ant Design `Table` `rowSelection` props from controlled selected keys.
 *
 * @param selectedTableKeys - Currently selected row keys (file ids).
 * @param setSelectedTableKeys - Updates selection when the user changes rows.
 */
export function useFilesRowSelection(
  selectedTableKeys: Key[],
  setSelectedTableKeys: (keys: Key[]) => void,
) {
  return useMemo(
    () => ({
      columnWidth: FILES_TABLE_SELECTION_COLUMN_WIDTH,
      selectedRowKeys: selectedTableKeys,
      onChange: (newSelectedKeys: Key[]) => {
        setSelectedTableKeys(newSelectedKeys);
      },
    }),
    [selectedTableKeys, setSelectedTableKeys],
  );
}
